import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getIsEditingGarmentMarkers = (state: RootState) => state.pages.editor.backgrounds.isEditingGarmentMarkers;

const isEditingGarmentMarkers = createSelector([getIsEditingGarmentMarkers], (value) => value);

export default isEditingGarmentMarkers;
